import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(with-layout)/(public)/profile/[nickname]/_components/breadcrumb/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(with-layout)/(public)/profile/[nickname]/_components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(with-layout)/(public)/profile/[nickname]/_components/tabs/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["root"] */ "/app/src/app/[lang]/(with-layout)/(public)/profile/[nickname]/layout.styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenContainer"] */ "/app/src/components/core/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LinguiClientProvider"] */ "/app/src/locales/index.tsx");
